import clsx from 'clsx';

interface Props {
  percent?: number;
}

export const ProgressBar = ({ percent = 0 }: Props) => {
  const isDone = !!percent && percent > 99;
  const isInProgress = !!percent && percent <= 99;
  const isUnActive = !percent;

  return (
    <div className="h-5 w-[50%] max-w-[60%] flex-1 rounded-[20px] bg-[#F0F0F0] flex items-center justify-center relative overflow-hidden">
      <div
        className={clsx(
          'absolute inset-0 z-1 transition-all',
          { 'bg-[var(--primary-color)]': isDone },
          { 'bg-[#FAAD14]': isInProgress },
          { 'bg-[#F0F0F0]': isUnActive },
        )}
        style={{
          width: percent + '%',
        }}
      />
      <p
        className={clsx(
          'text-[12px] relative z-20 line-clamp-1 px-2',
          { 'text-white': isDone },
          { 'text-black': isInProgress },
          { 'text-black': isUnActive },
        )}
      >
        {isDone && 'Bạn đã thỏa toàn bộ điều kiện của mã giảm giá'}
        {isInProgress && 'Chỉ còn vài điều kiện nữa, bạn thỏa được mã giảm giá'}
        {isUnActive && 'Chỉ còn vài điều kiện nữa, bạn thỏa được mã giảm giá'}
      </p>
    </div>
  );
};

